import { tenantAuthLogout } from "@ovrture/react-redux";
import { getTenantOrgId } from "../migration/TenantMigration";

export const insertLogoutMenu = (dispatch, isSurvey) => {
  const orgId = Number(getTenantOrgId());
  if (isSurvey) {
    const dropdownButton = document.querySelector(".dropdown-toggle");

    if (dropdownButton && dropdownButton.hasAttribute("onClick")) {
      dropdownButton.removeAttribute("onClick");
    }

    // Find the first <span> inside the button
    let firstSpan = dropdownButton.querySelector("span");
    if (
      orgId === 33 ||
      orgId === 38 ||
      orgId === 85 ||
      orgId === 89 ||
      orgId === 86
    ) {
      firstSpan = dropdownButton.querySelector("span.menu-text");
    }
    if ((orgId === 101 && !document.querySelector(".sb-pediatric")) || orgId === 102 || orgId === 103) {
      firstSpan = dropdownButton.querySelector("div.label");
    }
    if (firstSpan) {
      // If a span exists, update its text and remove siblings
      firstSpan.textContent = "Sign Out";

      // Apply new logic only for orgid === 95
      if (orgId === 94 || orgId === 85 || orgId === 89 || orgId === 86) {
        // Get the parent of the first span (could be a div or the button itself)
        const spanParent = firstSpan.parentElement;

        // If spanParent is not the dropdownButton, remove siblings of firstSpan within spanParent
        // Otherwise, remove siblings of firstSpan within dropdownButton
        if (spanParent !== dropdownButton) {
          let siblings = Array.from(spanParent.children);
          siblings.forEach((el) => {
            if (el !== firstSpan) {
              spanParent.removeChild(el);
            }
          });
        } else {
          let siblings = Array.from(dropdownButton.children);
          siblings.forEach((el) => {
            if (el !== firstSpan) {
              dropdownButton.removeChild(el);
            }
          });
        }
      } else {
        // Original logic for all other orgid values
        let siblings = Array.from(dropdownButton.children);
        siblings.forEach((el) => {
          if (el !== firstSpan) {
            dropdownButton.removeChild(el);
          }
        });
      }
    }

    // Add your click event
    dropdownButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      clickLogoutMenu(e, dispatch);
    });
    // let ul =
    //   document.querySelector("ul.menu-list")?.parentNode ||
    //   document.querySelector("ul.dropdown-menu")?.parentNode;
    // if (ul) {
    //   ul?.querySelector(".dropdown-toggle") &&
    //     (ul.querySelector(
    //       ".dropdown-toggle"
    //     ).innerHTML = `<span class="menu-text" id="menu-title">Sign Out</span>`);
    //   ul?.addEventListener("click", (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     clickLogoutMenu(e, dispatch);
    //   });
    // }
  } else {
    let ul =
      document.querySelector("ul.menu-list") ||
      document.querySelector("ul.dropdown-menu");
    if (ul) {
      ul.insertAdjacentHTML(
        "beforeend",
        "<li role='presentation'><a class='menu-item-logout' role='menuitem' tabindex='0'>Sign Out</a></li>"
      );
      ul?.querySelector(".menu-item-logout")?.addEventListener("click", (e) =>
        clickLogoutMenu(e, dispatch)
      );
    }
  }
};

export const getLoginUrl = () => {
  return (
    JSON?.parse(localStorage?.getItem("tenant_user"))?.loginUrl ||
    window.location.origin
  );
};

export const getIsReview = () => {
  let forReview = JSON?.parse(localStorage?.getItem("tenant_user"))?.loginUrl;
  if (forReview?.includes("?review=1")) {
    return true;
  }
  return false;
};

const clickLogoutMenu = (e, dispatch) => {
  let logoutUrl = getLoginUrl();
  dispatch(tenantAuthLogout());
  window.location.href = logoutUrl;
};

export const resetLoginUrl = (tenant_user) => {
  tenant_user.loginUrl = window?.location?.search?.includes("?token=")
    ? window.location.href.replace(window.location.search, "")
    : window.location.href;
  localStorage.setItem("tenant_user", JSON.stringify(tenant_user));
};
